module.exports = __webpack_public_path__ + "static/assets/0c361253f627ef4566a25cdf5e8ae160.png";